






















import { Component, Vue, Watch } from 'vue-property-decorator';
// import Compressor from 'compressorjs';
import FileUpload from 'vue-upload-component';

// Ref: https://github.com/lian-yue/vue-upload-component/blob/master/docs/views/examples/Simple.vue

@Component({
    components: {
        FileUpload,
    }
})
export default class UploadImgsBtn extends Vue {
    public files = [];
    public autoCompress = 1024 * 1024;

    public uploadButtonHover = false;

    public inputFilter(newFile: any, oldFile: any, prevent: any) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter picture
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          alert('Your choice is not a picture');
          return prevent();
        }

        // Create the 'blob' field for thumbnail preview
        newFile.blob = '';
        const URL = window.URL || (window as any).webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
      }
    }

    public inputFile(newFile: any, oldFile: any) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile);
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile);
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile);
      }
    }

    @Watch('files', {immediate: true})
    private onFilesChanged(val: any, oldVal: any) {
        this.$emit('files', this.files);
    }

}
